<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white rounded shadow">
      <input
        class="relative px-6 py-3 w-full rounded-r focus:shadow-outline"
        autocomplete="off"
        type="text"
        name="search"
        placeholder="Search By Phone Number"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue'],
}
</script>
